export enum ClickSource {
    SafelinkHandler,
    UrlDetectionContentHandler,
    OneDriveLinkHandler,
    WebPageLinkPreviewHandler,
    MailList,
    ConversationAttachmentWell,
    LoopUrlHandlerProvider,
    ActionableMessage,
    MessageExtension,
    M365Links,
    SafelinkComposeHandler,
    OnSendDialog,
    LinkContextMenu,
    M365LinksComposeHandler,
    MeetingAppsAboutAppDialog,
    CalendarJoinMeetingHandler,
}

export enum LinkHost {
    Attachment,
    Body,
}
